module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// /var/www/festagent_staging/shared/~/core-js/library/modules/_html.js
// module id = 238
// module chunks = 0 1